<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InformasiBongkarIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
